import { Component, Fragment, React } from "react";
import { connect } from "react-redux";

import { addSettings } from "../../../actions";
import {
  listForms,
  deleteForm,
  duplicateForm,
  previewForm,
  listChannelPartners,
  listClients,
  assignFormClients,
  assignFormSuppliers,
  assignFormAgents,
  enableZapForm,
  sendFormEmail,
  listSuppliers,
  unarchiveForm,
} from "./../../../config/forms_api_calls";
import {
  listActiveClients,
  listSingleClient,
} from "./../../../config/reseller_api_calls";

import { listAgents, listSuppliersNew } from "./../../../config/api_calls";
import $ from "jquery";
import DataTableExtended from "../../../components/Tables/DataTableExtended";
import { tableLoader } from "../../../components/ContentLoaders/table_loader";
import MsaWarning from "../ExtraComponents/MsaWarning";
import SettingsError from "../ExtraComponents/SettingsError";
import PageTitle from "../ExtraComponents/PageTitle";
import HelperClass from "./../../../config/helperClass";
import FormRenderer from "../../../components/Reseller/formRender";
import Tooltip from "@material-ui/core/Tooltip";
import dateFormat, { masks } from "dateformat";
import MutextField from "@material-ui/core/TextField";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import Select2 from "react-select";
import Autocomplete from "@material-ui/lab/Autocomplete";
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import RestoreIcon from "@material-ui/icons/Restore";
//import Select from "react-select";
import makeAnimated from "react-select/animated";
import localization from "../../../localization/enUS";
import UserPermissionHelper from "../../../components/Reseller/UserPermissionHelper";

const animatedComponents = makeAnimated();

const auth = new HelperClass();

class Forms extends Component {
  constructor() {
    super();

    this.state = {
      errorMessage: "",
      successMessage: "",
      successMessaged: "",
      errorMessaged: "",
      mainError: "",
      tableLoader: true,
      disabled: false,
      delete_form_acc: "",
      duplicate_form_acc: "",
      unarchive_form_acc: "",
      previewContent: [],
      channelPartnersList: [],
      selectedChannelPartners: [],
      selectAllChannelPartners: false,
      suppliersList: [],
      selectedSuppliers: [],
      selectAllSuppliers: false,
      assignModalLoader: true,
      errorMessageAssignModal: "",
      successMessageAssignModal: "",
      disableAssignBtn: false,
      clientsList: [],
      selectedClients: [],
      selectAllClients: false,
      active_formAccNo: "",
      activeFormTab: "active",
      archivedTableData: [],
      archivedTableLoader: true,
      zap_form_acc: "",
      zap_for_zap: "",
      zapierStatus: "",

      emailErrorMessageTitle: "",
      emailErrorMessage: "",
      emailSuccessMessage: "",
      select_clients: true,
      select_agents: "general",
      selected_client_accountno: null,
      all_active_clients: [],
      all_active_agents: [],
      all_active_suppliers: [],
      selected_agent_accountno: null,
      selected_emails: "",
      emailto: "",
      emailtoname: "",
      emailsubject: "",
      emailcontent: "",
      email_button: false,
      general_submission_id: "",
      client_submission_id: "",
      client_submission_type: "",
      agent_submission_id: "",
      errorMessageResend: "",
      successMessageResend: "",
      resendLoader: false,
      form_accountno: "",
      permissionsState: [],
      permission_add: 0,
      permission_edit: 0,
      permission_view: 0,
      permission_delete: 0,
      permission_email_form: 0,
      permission_assign_form: 0,
      permission_view_submission: 0,
      assignTab: "clients",
      userType: "",

      columnServices: [
        {
          name: "form_title",
          label: "Form Title",
          options: {
            customBodyRender: (value, tableMeta, updateValue) => {
              const forZap = tableMeta.rowData[7]; // Assuming `for_zap` is at index 7 in the data array
              return (
                <div
                  style={{ display: "flex", alignItems: "center", gap: "8px" }}
                >
                  <span>{value}</span>
                  {this.state.zapierStatus === "Yes" ? (
                    <>
                      {forZap === 1 && (
                        <img
                          src={
                            "../../assets/images/integrations/zapier_logo.png"
                          }
                          alt="Zapier"
                          title="Zapier-enabled form"
                          style={{
                            width: "30px",
                            height: "16px",
                            marginBottom: "15px",
                          }}
                        />
                      )}
                    </>
                  ) : null}
                </div>
              );
            },
          },
        },
        { name: "form_sequence", label: "Sequence" },
        {
          name: "show_on_dashboard",
          label: "For Dashboard",
          options: {
            customBodyRender: (value, tableMeta, updateValue) => {
              return <div>{this.format_dashboard(value)}</div>;
            },
          },
        },
        {
          name: "allow_multiple",
          label: "Multiple Submission",
          options: {
            customBodyRender: (value, tableMeta, updateValue) => {
              return <div>{this.format_multiple(value)}</div>;
            },
          },
        },
        {
          name: "is_default",
          label: "Default",
          options: {
            customBodyRender: (value, tableMeta, updateValue) => {
              return <div>{this.format_default(value, tableMeta)}</div>;
            },
          },
        },
        {
          name: "date_updated",
          label: "Date Updated",
          options: {
            customBodyRender: (value, tableMeta, updateValue) => {
              return <div>{value}</div>;
            },
          },
        },
        {
          name: "form_accountno",
          options: {
            display: false,
          },
        },
        {
          name: "for_zap",
          label: "Zap",
          options: {
            display: false,
          },
        },
        {
          name: "agent_default",
          label: "Agent Default",
          options: {
            display: false,
          },
        },
        {
          name: "supplier_default",
          label: "Supplier Default",
          options: {
            display: false,
          },
        },
        {
          name: "link_form",
          label: "Link Form",
          options: {
            display: false,
          },
        },
        {
          name: "is_sipnav",
          label: "Outbound SBC",
          options: {
            display: false,
          },
        },
        {
          name: "form_accountno",
          label: "View Submission",
          options: {
            customBodyRender: (value, tableMeta, updateValue) => {
              const isLinkForm = tableMeta.rowData[10] === 1; // index 10 is link_form
              return (
                <>
                  {this.state.permissionsState &&
                  this.state.permissionsState.length > 0 &&
                  this.state.permission_view_submission === 1 ? (
                    <Tooltip 
                      title={isLinkForm ? "Link Form - No Submissions" : "View Form Submissions"} 
                      placement="top"
                    >
                      <span>
                        <a
                          style={{ 
                            cursor: isLinkForm ? "not-allowed" : "pointer",
                            opacity: isLinkForm ? 0.5 : 1,
                            pointerEvents: isLinkForm ? "none" : "auto",
                          }}
                          onClick={() =>
                            !isLinkForm &&
                            this.addMenuHistory(
                              "/forms/view_form/" + tableMeta.rowData[6]
                            )
                          }
                          disabled={isLinkForm}
                        >
                          <span className="badge badge-outline-primary" style={{
                            opacity: isLinkForm ? 0.5 : 1,
                          }}>
                            <em className="icon ni ni-card-view"></em> View
                          </span>
                        </a>
                      </span>
                    </Tooltip>
                  ) : (
                    "---"
                  )}
                </>
              );
            },
          },
        },
        {
          name: "Actions",
          options: {
            customBodyRender: (value, tableMeta, updateValue) => {
              return (
                <div>
                  <div
                    className="nk-tb-col nk-tb-col-tools"
                    style={{ padding: "0px" }}
                  >
                    {this.state.permissionsState &&
                    this.state.permissionsState.length > 0 &&
                    (this.state.permission_edit === 1 ||
                      this.state.permission_delete === 1 ||
                      this.state.permission_view === 1 ||
                      this.state.permission_email_form === 1 ||
                      this.state.permission_assign_form === 1) ? (
                      <ul className="nk-tb-actions gx-1">
                        <li>
                          <div className="drodown">
                            <a
                              style={{ cursor: "pointer" }}
                              title="Other Actions"
                              className="dropdown-toggle btn btn-icon  btn-outline-light"
                              data-toggle="dropdown"
                            >
                              <em className="icon ni ni-more-h"></em>
                            </a>
                            <div className="dropdown-menu dropdown-menu-md dropdown-menu-right customStyle_dropdown-menu-md_forms">
                              <ul className="link-list-opt no-bdr">
                                {this.state.permissionsState &&
                                this.state.permissionsState.length > 0 &&
                                this.state.permission_view === 1 ? (
                                  <li>
                                    <Tooltip
                                      title="Preview Form"
                                      placement="top"
                                    >
                                      <a
                                        style={{ cursor: "pointer" }}
                                        onClick={() =>
                                          this.previewForm(
                                            value,
                                            tableMeta.rowData[6]
                                          )
                                        }
                                      >
                                        <em className="icon ni ni-card-view"></em>
                                        <span>Preview Form</span>
                                      </a>
                                    </Tooltip>
                                  </li>
                                ) : null}
                                {this.state.permissionsState &&
                                this.state.permissionsState.length > 0 &&
                                this.state.permission_edit === 1 &&
                                tableMeta.rowData[11] !== 1 ? (
                                  <li>
                                    <Tooltip title="Edit Form" placement="top">
                                      <a
                                        style={{ cursor: "pointer" }}
                                        onClick={() =>
                                          this.addMenuHistory(
                                            "/forms/edit_form/" +
                                              tableMeta.rowData[6]
                                          )
                                        }
                                        disabled={
                                          this.props.is_msa_signed === "No" ||
                                          this.props.defaultSettings ===
                                            "missing"
                                            ? true
                                            : false
                                        }
                                      >
                                        <em className="icon ni ni-edit"></em>
                                        <span>Edit</span>
                                      </a>
                                    </Tooltip>
                                  </li>
                                ) : null}
                                {this.state.permissionsState &&
                                this.state.permissionsState.length > 0 &&
                                this.state.permission_email_form === 1 ? (
                                  <li>
                                    <Tooltip
                                      title="Send this form as an email"
                                      placement="top"
                                    >
                                      <a
                                        style={{ cursor: "pointer" }}
                                        onClick={() =>
                                          this.emailForm(tableMeta.rowData[6])
                                        }
                                        disabled={
                                          this.props.is_msa_signed === "No" ||
                                          this.props.defaultSettings ===
                                            "missing"
                                            ? true
                                            : false
                                        }
                                      >
                                        <em className="icon ni ni-emails"></em>
                                        <span>Email Form</span>
                                      </a>
                                    </Tooltip>
                                  </li>
                                ) : null}
                                {this.state.permissionsState &&
                                this.state.permissionsState.length > 0 &&
                                this.state.permission_assign_form === 1 ? (
                                  <li>
                                    <a
                                      data-toggle="tooltip"
                                      data-placement="left"
                                      onClick={() =>
                                        this.openAssignFormModal(
                                          tableMeta.rowData[6]
                                        )
                                      }
                                      title={`Assign to ${localization.specificPortals.agentsText} and clients`}
                                      style={{ cursor: "pointer" }}
                                    >
                                      <em className="icon ni ni-user-check"></em>
                                      <span>Assign Form</span>
                                    </a>
                                  </li>
                                ) : null}
                                {this.state.permissionsState &&
                                this.state.permissionsState.length > 0 &&
                                this.state.permission_edit === 1 &&
                                tableMeta.rowData[11] !== 1 ? (
                                  <li>
                                    <Tooltip title="Duplicate Form" placement="top">
                                      <a
                                        style={{ cursor: "pointer" }}
                                        onClick={() =>
                                          this.openDuplicateForm(tableMeta.rowData[6])
                                        }
                                      >
                                        <em className="icon ni ni-copy"></em>
                                        <span>Duplicate</span>
                                      </a>
                                    </Tooltip>
                                  </li>
                                ) : null}
                                {this.state.permissionsState &&
                                this.state.permissionsState.length > 0 &&
                                this.state.permission_delete === 1 &&
                                tableMeta.rowData[11] !== 1 ? (
                                  <li>
                                    <a
                                      data-toggle="tooltip"
                                      data-placement="left"
                                      onClick={() =>
                                        this.openDelForm(tableMeta.rowData[6])
                                      }
                                      title="Delete Form"
                                      style={{ cursor: "pointer" }}
                                    >
                                      <em className="icon ni ni-trash"></em>
                                      <span>Delete</span>
                                    </a>
                                  </li>
                                ) : null}

                                {this.state.zapierStatus === "Yes" ? (
                                  <>
                                    <li>
                                      <a
                                        data-toggle="tooltip"
                                        data-placement="left"
                                        onClick={
                                          () =>
                                            this.openZapForm(
                                              tableMeta.rowData[6],
                                              tableMeta.rowData[7]
                                            ) // [6] = form_accountno, [7] = for_zap
                                        }
                                        title="Delete Form"
                                        style={{ cursor: "pointer" }}
                                      >
                                        <em
                                          className={`icon ni ${
                                            tableMeta.rowData[7] === 1
                                              ? "ni-cross"
                                              : "ni-check"
                                          }`}
                                        ></em>
                                        <span>
                                          {tableMeta.rowData[7] === 1
                                            ? "Remove for Zapier"
                                            : "Enable for Zapier"}
                                        </span>
                                      </a>
                                    </li>
                                  </>
                                ) : null}
                              </ul>
                            </div>
                          </div>
                        </li>
                      </ul>
                    ) : (
                      "---"
                    )}
                  </div>
                </div>
              );
            },
          },
        },
      ],
      archivedColumnServices: [
        {
          name: "form_title",
          label: "Form Title",
          options: {
            customBodyRender: (value, tableMeta, updateValue) => {
              return <span>{value}</span>;
            },
          },
        },
        { name: "form_sequence", label: "Sequence" },
        {
          name: "date_updated",
          label: "Date Updated",
          options: {
            customBodyRender: (value, tableMeta, updateValue) => {
              return value;
            },
          },
        },
        {
          name: "form_accountno",
          options: {
            display: false,
          },
        },
        {
          name: "Actions",
          options: {
            customBodyRender: (value, tableMeta, updateValue) => {
              return (
                <div>
                  <Tooltip title="Restore Form" placement="top">
                    <a
                      onClick={() =>
                        this.openUnarchiveForm(tableMeta.rowData[3])
                      }
                      style={{ cursor: "pointer" }}
                    >
                      <RestoreIcon
                        style={{
                          fontSize: 20,
                          color: "#198754",
                        }}
                      />
                    </a>
                  </Tooltip>
                </div>
              );
            },
          },
        },
      ],
    };
  }

  format_date = (value, tableMeta) => {
    let date = value;
    return dateFormat(date, "mm-dd-yyyy");
  };

  format_dashboard = (value, tableMeta) => {
    if (value === 1) {
      return (
        <Tooltip
          title={`This form will be displayed on assigned client and ${localization.specificPortals.agentText} dashboard.`}
          placement="top"
        >
          <span className="badge badge-outline-success">
            <em className="icon ni ni-done"></em> Yes
          </span>
        </Tooltip>
      );
    } else {
      return (
        <span className="badge badge-outline-light">
          <em className="icon ni ni-caution"></em> No
        </span>
      );
    }
  };

  format_multiple = (value, tableMeta) => {
    if (value === 1) {
      return (
        <Tooltip
          title="This form can be submitted multiple times."
          placement="top"
        >
          <span className="badge badge-outline-success">
            <em className="icon ni ni-done"></em> Yes
          </span>
        </Tooltip>
      );
    } else {
      return (
        <span className="badge badge-outline-light">
          <em className="icon ni ni-caution"></em> No
        </span>
      );
    }
  };

  format_submission = (value, tableMeta) => {
    return (
      <Tooltip title="View Form Submissions" placement="top">
        <a
          style={{ cursor: "pointer" }}
          onClick={() =>
            this.addMenuHistory("/forms/view_form/" + tableMeta.rowData[6])
          }
        >
          <span className="badge badge-outline-success">
            <em className="icon ni ni-done"></em> View
          </span>
        </a>
      </Tooltip>
    );
  };

  handleClientChange = (event, newSelectedOptions) => {
    const newSelectedClients = newSelectedOptions.map((option) => option.value);

    const selectAllClients =
      this.state.clientsList.length > 0 &&
      this.state.clientsList.length === newSelectedClients.length;

    this.setState({
      selectedClients: newSelectedClients,
      selectAllClients: selectAllClients,
    });
  };

  handleSupplierChange = (event, newSelectedOptions) => {
    const newSelectedClients = newSelectedOptions.map((option) => option.value);

    const selectAllClients =
      this.state.suppliersList.length > 0 &&
      this.state.suppliersList.length === newSelectedClients.length;

    this.setState({
      selectedSuppliers: newSelectedClients,
      selectAllSuppliers: selectAllClients,
    });
  };

  handleChannelPartnerChange = (event, newSelectedOptions) => {
    const newSelectedChannelPartners = newSelectedOptions.map(
      (option) => option.value
    );

    const selectAllChannelPartners =
      this.state.channelPartnersList.length > 0 &&
      this.state.channelPartnersList.length ===
        newSelectedChannelPartners.length;

    this.setState({
      selectedChannelPartners: newSelectedChannelPartners,
      selectAllChannelPartners: selectAllChannelPartners,
    });
  };

  format_default = (value, tableMeta) => {
    const isClient = tableMeta.rowData[4] === 1;
    const isPartner = tableMeta.rowData[8] === 1;
    const isSupplier = tableMeta.rowData[9] === 1;

    return (
      <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
        {isClient && (
          <Tooltip
            title="This form will be automatically assigned to new clients."
            placement="top"
          >
            <span className="badge badge-dot badge-primary">
              Client Default
            </span>
          </Tooltip>
        )}

        {isPartner && (
          <Tooltip
            title={`This form will be automatically assigned to new ${localization.specificPortals.agentsText}.`}
            placement="top"
          >
            <span className="badge badge-dot badge-secondary">
              {localization.specificPortals.agentLabel} Default
            </span>
          </Tooltip>
        )}

        {isSupplier && (
          <Tooltip
            title="This form will be automatically assigned to new suppliers."
            placement="top"
          >
            <span className="badge badge-dot badge-info">Supplier Default</span>
          </Tooltip>
        )}

        {!isClient && !isPartner && !isSupplier && (
          <Tooltip
            title="This form is not set as default for any user type."
            placement="top"
          >
            <span className="badge badge-dot badge-danger">
              Not Set as Default
            </span>
          </Tooltip>
        )}
      </div>
    );
  };

  async componentDidMount() {
    this.setState({ userType: auth.getUserType() });
    const servicesResponce = await listForms(
      auth.getAccount(),
      auth.getToken()
    );
    // console.log("servicesResponce.data.data: ", servicesResponce.data);

    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (servicesResponce.data.status === 404) {
      this.setState({
        tableData: [],
        mainError: "There is some error while getting the forms",
      });
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "success"
    ) {
      this.setState({
        tableData: servicesResponce.data.data.map((row) => ({
          ...row,
          date_updated: dateFormat(row.date_updated, "mm-dd-yyyy"),
        })),
        zapierStatus: servicesResponce.data.zapierStatus,
        tableLoader: false,
      });
    } else {
      this.setState({
        tableData: [],
        mainError: "There is some error while getting the forms",
      });
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.userRoleItems !== this.props.userRoleItems) {
      const canEdit = UserPermissionHelper.getAllRoles(
        this.props.userRoleItems,
        "forms",
        "forms"
      );
      // console.log("Can Edit Clients:", canEdit);

      this.setState({
        permissionsState: canEdit,
        permission_add: canEdit[0].add,
        permission_edit: canEdit[0].edit,
        permission_view: canEdit[0].view,
        permission_delete: canEdit[0].delete,
        permission_email_form: canEdit[0].email_form,
        permission_assign_form: canEdit[0].assign_form,
        permission_view_submission: canEdit[0].view_submission,
      });
      //console.log("Can Edit Clients:", canEdit);
    }
  }

  addMenuHistory = (link) => {
    this.props.props.history.push(link);
  };

  openDelForm = async (form_acc) => {
    this.setState({
      delete_form_acc: form_acc,
    });
    window.$("#modalDeleteAlert").modal("show");
  };

  closeDelForm = async () => {
    this.setState({
      delete_form_acc: "",
    });
    window.$("#modalDeleteAlert").modal("hide");
  };

  openDuplicateForm = async (form_acc) => {
    this.setState({
      duplicate_form_acc: form_acc,
    });
    window.$("#modalDuplicateAlert").modal("show");
  };

  closeDuplicateForm = async () => {
    this.setState({
      duplicate_form_acc: "",
    });
    window.$("#modalDuplicateAlert").modal("hide");
  };

  duplicateForm = async () => {
    let form_accountno = this.state.duplicate_form_acc;
    this.setState({
      errorMessage: "",
      successMessage: "",
      disabled: true,
    });
    const servicesResponce = await duplicateForm(
      auth.getAccount(),
      auth.getToken(),
      form_accountno
    );

    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.refreshPage();
    } else if (servicesResponce.data.status === 200) {
      this.setState({
        successMessaged: servicesResponce.data.message,
        disabled: false,
      });
      setTimeout(() => {
        this.closeDuplicateForm();
        this.componentDidMount();
      }, 1500);
    } else {
      this.setState({
        errorMessaged: servicesResponce.data.errors,
        disabled: false,
      });
    }

    setTimeout(() => {
      this.setState({ errorMessaged: "", successMessaged: "" });
    }, 2500);
  };

  deleteForm = async () => {
    let form_accountno = this.state.delete_form_acc;
    this.setState({
      errorMessage: "",
      successMessage: "",
      disabled: true,
    });
    const servicesResponce = await deleteForm(
      auth.getAccount(),
      auth.getToken(),
      form_accountno
    );
    // console.log("deleteForm: ", servicesResponce.data);

    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      //auth.logout();
    } else if (
      servicesResponce.data.status === 404 &&
      servicesResponce.data.message === "not_found"
    ) {
      this.setState({
        errorMessaged: "The form was not found.",
        successMessaged: "",
        disabled: false,
      });
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "success"
    ) {
      this.setState({
        errorMessaged: "",
        successMessaged: "Form deleted successfully.",
        disabled: false,
      });
      setTimeout(() => {
        window.location.reload();
      }, 2500);
    } else {
      this.setState({
        errorMessaged: "There is some error while deleting the form.",
        successMessaged: "",
        disabled: false,
      });
    }

    setTimeout(() => {
      this.setState({ errorMessaged: "", successMessaged: "" });
    }, 2500);
  };

  loadArchivedForms = async () => {
    this.setState({ archivedTableLoader: true });
    const servicesResponce = await listForms(
      auth.getAccount(),
      auth.getToken(),
      1
    );

    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "success"
    ) {
      this.setState({
        archivedTableData: servicesResponce.data.data.map((row) => ({
          ...row,
          date_updated: dateFormat(row.date_updated, "mm-dd-yyyy"),
        })),
        archivedTableLoader: false,
      });
    } else {
      this.setState({
        archivedTableData: [],
        archivedTableLoader: false,
      });
    }
  };

  openUnarchiveForm = async (form_acc) => {
    this.setState({
      unarchive_form_acc: form_acc,
      errorMessaged: "",
      successMessaged: "",
    });
    window.$("#modalUnarchiveAlert").modal("show");
  };

  closeUnarchiveForm = async () => {
    this.setState({
      unarchive_form_acc: "",
    });
    window.$("#modalUnarchiveAlert").modal("hide");
  };

  unarchiveFormAction = async () => {
    let form_accountno = this.state.unarchive_form_acc;
    this.setState({
      errorMessaged: "",
      successMessaged: "",
      disabled: true,
    });
    const servicesResponce = await unarchiveForm(
      auth.getAccount(),
      auth.getToken(),
      form_accountno
    );

    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "success"
    ) {
      this.setState({
        errorMessaged: "",
        successMessaged: "Form restored successfully.",
        disabled: false,
      });
      setTimeout(() => {
        window.location.reload();
      }, 2500);
    } else {
      this.setState({
        errorMessaged: "There is some error while restoring the form.",
        successMessaged: "",
        disabled: false,
      });
    }

    setTimeout(() => {
      this.setState({ errorMessaged: "", successMessaged: "" });
    }, 2500);
  };

  previewForm = async (value, form_accountno) => {
    this.setState({
      errorMessage: "",
      successMessage: "",
      disabled: true,
    });
    const servicesResponce = await previewForm(
      auth.getAccount(),
      auth.getToken(),
      form_accountno
    );
    // console.log("previewForm: ", servicesResponce.data);

    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      //auth.logout();
    } else if (
      servicesResponce.data.status === 404 &&
      servicesResponce.data.message === "not_found"
    ) {
      this.setState({
        errorMessage: "The form was not found.",
        successMessage: "",
        disabled: false,
      });
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "success"
    ) {
      const previewContent = (
        <FormRenderer
          formData={JSON.parse(servicesResponce.data.data[0]["form_content"])}
          formTitle={servicesResponce.data.data[0]["form_title"]}
          formDesc={servicesResponce.data.data[0]["form_desc"]}
          formGroups={JSON.parse(servicesResponce.data.data[0]["groups"])}

          // id={this.state.forms[0].id}
          // setShowResponse={(value) => this.setState({ showResponse: value })}
        />
      );
      this.setState({ previewContent }, () => {
        window.$("#modalPreviewForm").modal("show");
      });
    } else {
      this.setState({
        errorMessage: "There is some error while previewing the form.",
        successMessage: "",
        disabled: false,
      });
    }

    setTimeout(() => {
      this.setState({ errorMessaged: "", successMessaged: "" });
    }, 2500);
  };

  openAssignFormModal = async (form_accountno) => {
    this.setState({
      active_formAccNo: form_accountno,
    });
    this.listChannelPartners(form_accountno);
    this.listClients(form_accountno);
    this.listSuppliers(form_accountno);
  };

  listSuppliers = async (form_accountno) => {
    try {
      const servicesResponse = await listSuppliers(
        auth.getAccount(),
        auth.getToken(),
        form_accountno
      );

      // console.log("supplierResponse.data: ", servicesResponse.data);

      if (
        servicesResponse.data.status === 403 ||
        servicesResponse.data.errors === "authentication missing" ||
        servicesResponse.data.errors === "jwt expired"
      ) {
        auth.logout();
      } else if (servicesResponse.data.status === 404) {
        this.setState({
          formLoader: false,
        });
      } else if (
        servicesResponse.data.status === 200 &&
        servicesResponse.data.message === "success"
      ) {
        // Map suppliers correctly (backend returns objects, not arrays)
        let channelPartners = servicesResponse.data.data.map((agent) => ({
          value: agent[8],
          label: agent[2] + " (" + agent[1] + ")",
        }));

        // Ensure selected_agents is always an array
        const selectedChannelPartners = Array.isArray(
          servicesResponse.data.selected_agents
        )
          ? servicesResponse.data.selected_agents.map(
              (agent) => agent.accountno
            )
          : [];

        // Check if all are selected
        const selectAllChannelPartners =
          channelPartners.length > 0 &&
          channelPartners.every((agent) =>
            selectedChannelPartners.includes(agent.value)
          );

        // Update state
        this.setState({
          suppliersList: channelPartners,
          selectedSuppliers: selectedChannelPartners,
          selectAllSuppliers: selectAllChannelPartners,
          assignModalLoader: false,
        });

        // Show modal
        window.$("#modalAssignForm").modal("show");
      }
    } catch (err) {
      console.error("Error loading suppliers:", err);
      this.setState({ assignModalLoader: false });
    }
  };

  listChannelPartners = async (form_accountno) => {
    const servicesResponse = await listChannelPartners(
      auth.getAccount(),
      auth.getToken(),
      form_accountno
    );

    // console.log("agentsResponse.data.data: ", servicesResponse.data);

    if (
      servicesResponse.data.status === 403 ||
      servicesResponse.data.errors === "authentication missing" ||
      servicesResponse.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (servicesResponse.data.status === 404) {
      this.setState({
        formLoader: false,
      });
    } else if (
      servicesResponse.data.status === 200 &&
      servicesResponse.data.message === "success"
    ) {
      let channelPartners = servicesResponse.data.data.map((agent) => ({
        value: agent[8],
        label: agent[2] + " (" + agent[1] + ")",
      }));

      const selectedChannelPartners = servicesResponse.data.selected_agents.map(
        (agent) => agent.accountno
      );

      const selectAllChannelPartners =
        channelPartners.length > 0 &&
        channelPartners.every((agent) =>
          selectedChannelPartners.includes(agent.value)
        );

      this.setState({
        channelPartnersList: channelPartners,
        selectedChannelPartners: selectedChannelPartners,
        selectAllChannelPartners: selectAllChannelPartners,
        assignModalLoader: false,
      });

      window.$("#modalAssignForm").modal("show");
    }
  };

  listClients = async (form_accountno) => {
    const listClientsResponse = await listClients(
      auth.getAccount(),
      auth.getToken(),
      form_accountno
    );

    // console.log("listClientsResponse: ", listClientsResponse.data);

    if (
      listClientsResponse.data.status === 403 ||
      listClientsResponse.data.errors === "authentication missing" ||
      listClientsResponse.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (listClientsResponse.data.status === 404) {
      // Handle 404 error if needed
    } else if (
      listClientsResponse.data.status === 200 &&
      listClientsResponse.data.message === "success"
    ) {
      let clients = listClientsResponse.data.data.map((client) => ({
        value: client[0],
        label: client[1] + " (" + client[2] + ")",
      }));

      const selectedClients = listClientsResponse.data.selected_clients.map(
        (client) => client.accountno
      );

      const selectAllClients =
        clients.length > 0 &&
        clients.every((client) => selectedClients.includes(client.value));

      this.setState({
        clientsList: clients,
        selectedClients: selectedClients,
        selectAllClients: selectAllClients,
      });
    } else {
      // Handle other responses or errors
    }
  };

  handleSelectAllChannelPartnersChange = () => {
    const { selectAllChannelPartners, channelPartnersList } = this.state;
    if (selectAllChannelPartners) {
      this.setState({
        selectedChannelPartners: [],
        selectAllChannelPartners: false,
      });
    } else {
      const allAgentValues = channelPartnersList.map((agent) => agent.value);
      this.setState({
        selectedChannelPartners: allAgentValues,
        selectAllChannelPartners: true,
      });
    }
  };

  handleSelectChannelPartnerChange = (agentValue) => {
    this.setState((prevState) => {
      const selectedIndex =
        prevState.selectedChannelPartners.indexOf(agentValue);
      const newSelectedChannelPartners = [...prevState.selectedChannelPartners];

      if (selectedIndex === -1) {
        newSelectedChannelPartners.push(agentValue);
      } else {
        newSelectedChannelPartners.splice(selectedIndex, 1);
      }

      const allChannelPartnersSelected = prevState.channelPartnersList.every(
        (agent) => newSelectedChannelPartners.includes(agent.value)
      );

      return {
        selectedChannelPartners: newSelectedChannelPartners,
        selectAllChannelPartners: allChannelPartnersSelected,
      };
    });
  };

  handleSelectAllClientsChange = () => {
    const { selectAllClients, clientsList } = this.state;
    if (selectAllClients) {
      this.setState({
        selectedClients: [],
        selectAllClients: false,
      });
    } else {
      const allClientValues = clientsList.map((client) => client.value);
      this.setState({
        selectedClients: allClientValues,
        selectAllClients: true,
      });
    }
  };

  handleSelectAllSuppliersChange = () => {
    const { selectAllSuppliers, suppliersList } = this.state;
    if (selectAllSuppliers) {
      this.setState({
        selectedSuppliers: [],
        selectAllSuppliers: false,
      });
    } else {
      const allClientValues = suppliersList.map((client) => client.value);
      this.setState({
        selectedSuppliers: allClientValues,
        selectAllSuppliers: true,
      });
    }
  };

  handleSelectClientChange = (clientValue) => {
    this.setState((prevState) => {
      const selectedIndex = prevState.selectedClients.indexOf(clientValue);
      const newSelectedClients = [...prevState.selectedClients];

      if (selectedIndex === -1) {
        newSelectedClients.push(clientValue);
      } else {
        newSelectedClients.splice(selectedIndex, 1);
      }

      const allClientsSelected = prevState.clientsList.every((client) =>
        newSelectedClients.includes(client.value)
      );

      return {
        selectedClients: newSelectedClients,
        selectAllClients: allClientsSelected,
      };
    });
  };

  handleSubmitAssignFormClient = async () => {
    const { selectedClients, active_formAccNo } = this.state;
    const assignFormResponse = await assignFormClients(
      auth.getAccount(),
      auth.getToken(),
      selectedClients,
      active_formAccNo
    );

    // console.log("assignFormResponse: ", assignFormResponse.data);

    if (
      assignFormResponse.data.status === 403 ||
      assignFormResponse.data.errors === "authentication missing" ||
      assignFormResponse.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (
      assignFormResponse.data.status === 404 &&
      assignFormResponse.data.message === "assigning_error"
    ) {
      this.setState({
        errorMessageAssignModal:
          "There was some error while assigning the form to selected Clients.",
      });
    } else if (
      assignFormResponse.data.status === 200 &&
      assignFormResponse.data.message === "success"
    ) {
      this.setState({
        successMessageAssignModal: "Form assigned to selected Clients.",
      });
      /*setTimeout(() => {
        window.location.reload();
      }, 2500);*/
    } else {
      this.setState({
        errorMessageAssignModal:
          "There was some error while assigning the form to selected Clients.",
      });
    }
    setTimeout(() => {
      this.setState({
        successMessageAssignModal: "",
        errorMessageAssignModal: "",
      });
      window.$("#modalAssignForm").modal("hide");
    }, 2500);
  };

  handleSubmitAssignFormSupplier = async () => {
    const { selectedSuppliers, active_formAccNo } = this.state;
    const assignFormResponse = await assignFormSuppliers(
      auth.getAccount(),
      auth.getToken(),
      selectedSuppliers,
      active_formAccNo
    );

    // console.log("assignFormResponse: ", assignFormResponse.data);

    if (
      assignFormResponse.data.status === 403 ||
      assignFormResponse.data.errors === "authentication missing" ||
      assignFormResponse.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (
      assignFormResponse.data.status === 404 &&
      assignFormResponse.data.message === "assigning_error"
    ) {
      this.setState({
        errorMessageAssignModal:
          "There was some error while assigning the form to selected Suppliers.",
      });
    } else if (
      assignFormResponse.data.status === 200 &&
      assignFormResponse.data.message === "success"
    ) {
      this.setState({
        successMessageAssignModal: "Form assigned to selected Supplier.",
      });
      /*setTimeout(() => {
        window.location.reload();
      }, 2500);*/
    } else {
      this.setState({
        errorMessageAssignModal:
          "There was some error while assigning the form to selected Suppliers.",
      });
    }
    setTimeout(() => {
      this.setState({
        successMessageAssignModal: "",
        errorMessageAssignModal: "",
      });
      window.$("#modalAssignForm").modal("hide");
    }, 2500);
  };

  handleSubmitAssignFormAgents = async () => {
    const { selectedChannelPartners, active_formAccNo } = this.state;
    const assignFormResponse = await assignFormAgents(
      auth.getAccount(),
      auth.getToken(),
      selectedChannelPartners,
      active_formAccNo
    );

    // console.log("assignFormResponse: ", assignFormResponse.data);

    if (
      assignFormResponse.data.status === 403 ||
      assignFormResponse.data.errors === "authentication missing" ||
      assignFormResponse.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (
      assignFormResponse.data.status === 404 &&
      assignFormResponse.data.message === "assigning_error"
    ) {
      this.setState({
        errorMessageAssignModal: `There was some error while assigning the form to selected ${localization.specificPortals.agentsLabel}.`,
      });
    } else if (
      assignFormResponse.data.status === 200 &&
      assignFormResponse.data.message === "success"
    ) {
      this.setState({
        successMessageAssignModal: `Form assigned to selected ${localization.specificPortals.agentsLabel}.`,
      });
      /*setTimeout(() => {
        window.location.reload();
      }, 2500);*/
    } else {
      this.setState({
        errorMessageAssignModal: `There was some error while assigning the form to selected ${localization.specificPortals.agentsLabel}.`,
      });
    }
    setTimeout(() => {
      this.setState({
        successMessageAssignModal: "",
        errorMessageAssignModal: "",
      });
      window.$("#modalAssignForm").modal("hide");
    }, 2500);
  };

  openZapForm = (form_acc, for_zap) => {
    this.setState({
      zap_form_acc: form_acc,
      zap_for_zap: for_zap,
    });
    window.$("#modalZapAlert").modal("show");
  };

  closeZapForm = () => {
    this.setState({
      zap_form_acc: "",
      zap_for_zap: 0,
    });
    window.$("#modalZapAlert").modal("hide");
  };

  enableZapForm = async () => {
    const { zap_form_acc, zap_for_zap } = this.state;
    const new_zap_status = zap_for_zap === 1 ? 0 : 1;

    this.setState({
      errorMessage: "",
      successMessage: "",
      disabled: true,
    });

    const servicesResponce = await enableZapForm(
      auth.getAccount(),
      auth.getToken(),
      zap_form_acc,
      new_zap_status
    );

    // console.log("zapForm: ", servicesResponce.data);

    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      // auth.logout();
    } else if (
      servicesResponce.data.status === 404 &&
      servicesResponce.data.message === "not_found"
    ) {
      this.setState({
        errorMessaged: "The form was not found.",
        successMessaged: "",
        disabled: false,
      });
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "success"
    ) {
      const successText =
        new_zap_status === 1
          ? "Form has been successfully enabled for Zapier."
          : "Form has been removed for Zapier.";

      this.setState({
        errorMessaged: "",
        successMessaged: successText,
        disabled: false,
      });

      setTimeout(() => {
        window.location.reload();
      }, 2500);
    } else {
      const errorText =
        new_zap_status === 1
          ? "There was an error enabling this form for Zapier."
          : "There was an error removing this form for Zapier.";

      this.setState({
        errorMessaged: errorText,
        successMessaged: "",
        disabled: false,
      });
    }

    setTimeout(() => {
      this.setState({ errorMessaged: "", successMessaged: "" });
    }, 2500);
  };

  handleChangeSelectAgents = async (event) => {
    const { target } = event;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const { name } = target;

    this.setState({
      [name]: value,
      emailto: "",
    });

    //console.log("handleChangeCheckbox:", name + " " + value);
  };

  handleChangeSearch = async (changed_value) => {
    // console.log("handleChangeSearch: ", changed_value);

    if (changed_value) {
      if (changed_value.value === "other") {
        this.setState({
          selected_emails: changed_value.value,
          emailto: "",
          emailtoname: "",
        });
      } else {
        let emails = changed_value.value.split("###");
        this.setState(
          (prevState) => ({
            client_accountno: changed_value.value,
            selected_client_accountno: changed_value,
            selected_emails: "",
            emailto: emails[0],
            emailtoname: emails[1],
          }),
          () => {
            // This callback function is called right after the state is updated
            // console.log("Updated state:", this.state.client_accountno);
          }
        );
      }
    } else {
      this.setState(
        {
          client_accountno: null,
          selected_client_accountno: null,
          emailto: "",
          emailtoname: "",
          selected_emails: "",
        },
        () => {
          // console.log("Cleared selection");
        }
      );
    }
  };

  handleChangeSearchAgents = async (changed_value) => {
    // console.log("handleChangeSearch: ", changed_value);

    if (changed_value) {
      if (changed_value.value === "other") {
        this.setState({
          selected_emails: changed_value.value,
          emailto: "",
          emailtoname: "",
        });
      } else {
        let emails = changed_value.value.split("###");
        this.setState(
          (prevState) => ({
            agent_accountno: changed_value.value,
            selected_agent_accountno: changed_value,
            selected_emails: "",
            emailtoname: emails[1],
            emailto: emails[0],
          }),
          () => {
            // This callback function is called right after the state is updated
            // console.log("Updated state:", this.state.agent_accountno);
          }
        );
      }
    } else {
      this.setState(
        {
          agent_accountno: null,
          selected_agent_accountno: null,
          emailto: "",
          emailtoname: "",
          selected_emails: "",
        },
        () => {
          // console.log("Cleared selection");
        }
      );
    }
  };

  emailForm = async (form_accountno) => {
    this.setState({
      emailErrorMessageTitle: "",
      emailErrorMessage: "",
      emailSuccessMessage: "",
      emailsubject: "",
      emailto: "",
      emailtoname: "",
      emailcontent: "",
      form_accountno: form_accountno,
    });
    this.listAllActiveClients();
    this.listActiveAgents();
    this.listActiveSuppliers();
    window.$("#modalEmailForm").modal("show");
  };

  listAllActiveClients = async () => {
    const servicesResponce = await listActiveClients(
      auth.getAccount(),
      auth.getToken()
    );
    // console.log("listAllActiveClients: ", servicesResponce.data);

    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      //auth.logout();
    } else if (
      servicesResponce.data.status === 404 &&
      servicesResponce.data.message === "not_found"
    ) {
      this.setState({
        errorMessage: "The question not found.",
      });
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "success"
    ) {
      let all_clients = [];
      if (
        servicesResponce.data.all_data &&
        servicesResponce.data.all_data.length > 0
      ) {
        for (let i = 0; i < servicesResponce.data.all_data.length; i++) {
          let newArr = {
            label:
              servicesResponce.data.all_data[i]["name"] +
              " (" +
              servicesResponce.data.all_data[i]["comp_name"] +
              ")",
            value:
              servicesResponce.data.all_data[i]["email"] +
              "###" +
              servicesResponce.data.all_data[i]["name"],
          };
          all_clients.push(newArr);
        }
        let newArr2 = {
          label: "Other",
          value: "other",
        };
        all_clients.push(newArr2);
      }
      this.setState({
        all_active_clients: all_clients,
      });
    } else {
      this.setState({
        errorMessage: "",
      });
    }
  };

  listActiveAgents = async () => {
    const servicesResponce = await listAgents(
      auth.getAccount(),
      auth.getToken()
    );

    // console.log("listActiveAgents: ", servicesResponce.data);

    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (servicesResponce.data.status === 404) {
      this.setState({
        formLoader: false,
      });
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "success"
    ) {
      let all_clients = [];
      if (servicesResponce.data.data && servicesResponce.data.data.length > 0) {
        for (let i = 0; i < servicesResponce.data.data.length; i++) {
          let newArr = {
            label:
              servicesResponce.data.data[i][1] +
              " (" +
              servicesResponce.data.data[i][2] +
              ")",
            value:
              servicesResponce.data.data[i][3] +
              "###" +
              servicesResponce.data.data[i][1],
          };
          all_clients.push(newArr);
        }
        let newArr2 = {
          label: "Other",
          value: "other",
        };
        all_clients.push(newArr2);
      }
      this.setState({
        all_active_agents: all_clients,
      });
    }
  };

  listActiveSuppliers = async () => {
    const servicesResponce = await listSuppliersNew(
      auth.getAccount(),
      auth.getToken()
    );

    // console.log("listActiveSuppliers: ", servicesResponce.data);

    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (servicesResponce.data.status === 404) {
      this.setState({
        formLoader: false,
      });
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "success"
    ) {
      let all_clients = [];
      if (servicesResponce.data.data && servicesResponce.data.data.length > 0) {
        for (let i = 0; i < servicesResponce.data.data.length; i++) {
          let newArr = {
            label:
              servicesResponce.data.data[i][1] +
              " (" +
              servicesResponce.data.data[i][2] +
              ")",
            value:
              servicesResponce.data.data[i][3] +
              "###" +
              servicesResponce.data.data[i][1],
          };
          all_clients.push(newArr);
        }
        let newArr2 = {
          label: "Other",
          value: "other",
        };
        all_clients.push(newArr2);
      }
      this.setState({
        all_active_suppliers: all_clients,
      });
    }
  };

  validateEmailAdd = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const isValidEmail = emailRegex.test(email);
    //console.log("isValidEmail: " + " " + email + " = " + isValidEmail);
    if (isValidEmail) {
      return true;
    }
    return false;
  };

  fieldValidation = () => {
    let { emailtoname, emailto, emailsubject, emailcontent } = this.state;

    if (emailtoname === "") {
      this.setState({
        emailErrorMessageTitle: "Missing Fields",
        emailErrorMessage: "Name is required.",
      });
      return false;
    } else if (emailto === "") {
      this.setState({
        emailErrorMessageTitle: "Missing Fields",
        emailErrorMessage: "To email address is required.",
      });
      return false;
    } else if (this.validateEmailAdd(emailto) === false) {
      this.setState({
        emailErrorMessageTitle: "Invalid Format",
        emailErrorMessage: "Invalid email address format.",
      });
      return false;
    } else if (emailsubject === "") {
      this.setState({
        emailErrorMessageTitle: "Missing Fields",
        emailErrorMessage: "Subject is required.",
      });
      return false;
    } else if (emailcontent === "") {
      this.setState({
        emailErrorMessageTitle: "Missing Fields",
        emailErrorMessage: "Custom content is required.",
      });
      return false;
    } else {
      this.setState({
        emailErrorMessageTitle: "",
        emailErrorMessage: "",
      });
    }
    return true;
  };

  submitFormEmail = async () => {
    const {
      form_accountno,
      emailtoname,
      emailto,
      emailsubject,
      emailcontent,
      select_agents,
      selected_emails,
    } = this.state;

    if (this.fieldValidation() === true) {
      this.setState({
        email_button: true,
        emailErrorMessage: "",
        emailErrorMessageTitle: "",
        emailSuccessMessage: "",
      });
      const servicesResponce = await sendFormEmail(
        auth.getAccount(),
        auth.getToken(),
        form_accountno,
        emailtoname,
        emailto,
        emailsubject,
        emailcontent,
        select_agents,
        selected_emails
      );
      // console.log("submitOrderEmail: ", servicesResponce.data);

      if (
        servicesResponce.data.status === 403 ||
        servicesResponce.data.errors === "authentication missing" ||
        servicesResponce.data.errors === "jwt expired"
      ) {
        auth.logout();
      } else if (
        servicesResponce.data.status === 404 &&
        servicesResponce.data.message === "already_sent"
      ) {
        this.setState({
          emailErrorMessageTitle: "Already Sent",
          emailErrorMessage:
            "This form has already been sent to the email and is still not submitted.",
          email_button: false,
        });
      } else if (
        servicesResponce.data.status === 404 &&
        servicesResponce.data.message === "insert_error"
      ) {
        this.setState({
          emailErrorMessageTitle: "System Error",
          emailErrorMessage: "This is some error while sending the form.",
          email_button: false,
        });
      } else if (
        servicesResponce.data.status === 200 &&
        servicesResponce.data.message === "success"
      ) {
        this.setState({
          emailSuccessMessage: "Email sent successfully.",
          payment_status: servicesResponce.data.data,
          emailErrorMessageTitle: "",
          emailErrorMessage: "",
          emailsubject: "",
          emailto: "",
          emailtoname: "",
          emailcontent: "",
          email_button: false,
        });
        /*setTimeout(() => {
          window.location.reload();
        }, 3000);*/
      } else {
        this.setState({
          emailErrorMessageTitle: "System Error",
          emailErrorMessage:
            "There is some error while processing your request.",
          email_button: false,
        });
      }
    }

    setTimeout(() => {
      this.setState({
        emailErrorMessage: "",
        emailSuccessMessage: "",
      });
    }, 4000);
  };

  handleChange = async (event) => {
    const { target } = event;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const { name } = target;

    this.setState({
      [name]: value,
    });
  };

  render() {
    const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
    const checkedIcon = <CheckBoxIcon fontSize="small" />;
    return (
      <div className="nk-content " id="Services_Block">
        <div className="container-fluid">
          {this.props.defaultSettings === "missing" &&
          this.props.from !== "dashboard" ? (
            <SettingsError />
          ) : null}
          {/* MSA WARNING  START*/}
          {this.props.is_msa_signed === "No" &&
          this.props.from !== "dashboard" ? (
            <MsaWarning />
          ) : null}

          {/* MSA WARNING END */}

          <div className="nk-content-inner">
            <div className="nk-content-body">
              {/* PAGE TITLE START */}
              <div className="nk-block-head nk-block-head-sm">
                <div className="nk-block-between">
                  <div className="nk-block-head-content">
                    <h3 className="nk-block-title page-title">
                      <PageTitle name="Forms" icon="icon ni ni-list-check" />
                    </h3>
                  </div>
                  <div className="nk-block-head-content" id="HeadContentAgent">
                    <div className="toggle-wrap nk-block-tools-toggle">
                      <a
                        href="#"
                        className="btn btn-icon btn-trigger toggle-expand mr-n1"
                        data-target="pageMenu"
                      >
                        <em className="icon ni ni-more-v"></em>
                      </a>
                      <div
                        className="toggle-expand-content"
                        data-content="pageMenu"
                      >
                        <ul className="nk-block-tools g-3">
                          {this.state.permissionsState &&
                          this.state.permissionsState.length > 0 &&
                          this.state.permission_add === 1 ? (
                            <li className="nk-block-tools-opt">
                              <a
                                style={{ cursor: "pointer", color: "#fff" }}
                                onClick={() =>
                                  this.addMenuHistory("/forms/add_form")
                                }
                                className="btn btn-primary"
                              >
                                <em className="icon ni ni-plus"></em> Add New
                              </a>
                            </li>
                          ) : null}
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* PAGE TITLE END */}
              <div className="nk-block">
                <div className="row g-gs">
                  {/* Table 5th Col Start */}
                  <div className="col-xxl-12">
                    <div className="nk-block nk-block-lg">
                      <div className="card card-bordered">
                        <div className="card-inner">
                          {this.state.mainError !== "" ? (
                            <div className="example-alert">
                              <div className="alert alert-pro alert-danger">
                                <div className="alert-text">
                                  <h4>Error</h4>
                                  <p>{this.state.mainError}</p>
                                </div>
                              </div>
                            </div>
                          ) : null}
                          <ul className="nav nav-tabs">
                            <li className="nav-item">
                              <a
                                className={`nav-link ${this.state.activeFormTab === "active" ? "active" : ""}`}
                                style={{ cursor: "pointer" }}
                                onClick={() =>
                                  this.setState({ activeFormTab: "active" })
                                }
                              >
                                Active Forms
                              </a>
                            </li>
                            <li className="nav-item">
                              <a
                                className={`nav-link ${this.state.activeFormTab === "archived" ? "active" : ""}`}
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  this.setState({ activeFormTab: "archived" });
                                  this.loadArchivedForms();
                                }}
                              >
                                Archived Forms
                              </a>
                            </li>
                          </ul>
                          <div className="tab-content" style={{ marginTop: "15px" }}>
                            {this.state.activeFormTab === "active" ? (
                              <div>
                                {/* START DATATABLE */}
                                {this.state.tableLoader === true ? (
                                  tableLoader()
                                ) : (
                                  <DataTableExtended
                                    columns={this.state.columnServices}
                                    tableData={this.state.tableData}
                                    title=""
                                  />
                                )}
                                {/* END TABLE */}
                              </div>
                            ) : (
                              <div>
                                {this.state.archivedTableLoader === true ? (
                                  tableLoader()
                                ) : (
                                  <DataTableExtended
                                    columns={this.state.archivedColumnServices}
                                    tableData={this.state.archivedTableData}
                                    title=""
                                  />
                                )}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Table 5th Col End */}
                </div>
              </div>
              {/* START DELETE MODAL  */}
              <div className="modal fade" tabIndex="-1" id="modalDeleteAlert">
                <div className="modal-dialog" role="document">
                  <div className="modal-content">
                    <a
                      style={{ cursor: "pointer" }}
                      className="close"
                      onClick={() => this.closeDelForm()}
                    >
                      <em className="icon ni ni-cross"></em>
                    </a>
                    <div className="modal-body modal-body-lg text-center">
                      <div className="nk-modal">
                        <em className="nk-modal-icon icon icon-circle icon-circle-xxl ni ni-trash bg-danger"></em>

                        <h4 className="nk-modal-title">Delete Form?</h4>
                        <div className="nk-modal-text">
                          {this.state.errorMessaged !== "" ? (
                            <div
                              className="example-alert"
                              style={{ marginBottom: "15px" }}
                            >
                              <div className="alert alert-pro alert-danger">
                                <div className="alert-text">
                                  <h4>Error</h4>
                                  <p>{this.state.errorMessaged}</p>
                                </div>
                              </div>
                            </div>
                          ) : null}
                          {this.state.successMessaged !== "" ? (
                            <div
                              className="example-alert"
                              style={{ marginBottom: "15px" }}
                            >
                              <div className="alert alert-pro alert-success">
                                <div className="alert-text">
                                  <h4>Success</h4>
                                  <p>{this.state.successMessaged}</p>
                                </div>
                              </div>
                            </div>
                          ) : null}
                          <div className="caption-text">
                            Are you sure you want to delete this form?
                          </div>
                        </div>
                        <div className="nk-modal-action">
                          <a
                            style={{ cursor: "pointer" }}
                            className="btn btn-lg btn-mw btn-primary"
                            onClick={() => this.closeDelForm()}
                          >
                            CANCEL
                          </a>
                          {"  "}
                          <button
                            style={{ cursor: "pointer" }}
                            className={"btn btn-lg btn-mw btn-danger"}
                            onClick={() => {
                              this.deleteForm();
                            }}
                            disabled={this.state.disabled ? true : false}
                          >
                            DELETE
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* START UNARCHIVE MODAL  */}
              <div className="modal fade" tabIndex="-1" id="modalUnarchiveAlert">
                <div className="modal-dialog" role="document">
                  <div className="modal-content">
                    <a
                      style={{ cursor: "pointer" }}
                      className="close"
                      onClick={() => this.closeUnarchiveForm()}
                    >
                      <em className="icon ni ni-cross"></em>
                    </a>
                    <div className="modal-body modal-body-lg text-center">
                      <div className="nk-modal">
                        <em className="nk-modal-icon icon icon-circle icon-circle-xxl ni ni-undo bg-success"></em>

                        <h4 className="nk-modal-title">Restore Form?</h4>
                        <div className="nk-modal-text">
                          {this.state.errorMessaged !== "" ? (
                            <div
                              className="example-alert"
                              style={{ marginBottom: "15px" }}
                            >
                              <div className="alert alert-pro alert-danger">
                                <div className="alert-text">
                                  <h4>Error</h4>
                                  <p>{this.state.errorMessaged}</p>
                                </div>
                              </div>
                            </div>
                          ) : null}
                          {this.state.successMessaged !== "" ? (
                            <div
                              className="example-alert"
                              style={{ marginBottom: "15px" }}
                            >
                              <div className="alert alert-pro alert-success">
                                <div className="alert-text">
                                  <h4>Success</h4>
                                  <p>{this.state.successMessaged}</p>
                                </div>
                              </div>
                            </div>
                          ) : null}
                          <div className="caption-text">
                            Are you sure you want to restore this form?
                          </div>
                        </div>
                        <div className="nk-modal-action">
                          <a
                            style={{ cursor: "pointer" }}
                            className="btn btn-lg btn-mw btn-light"
                            onClick={() => this.closeUnarchiveForm()}
                          >
                            CANCEL
                          </a>
                          {"  "}
                          <button
                            style={{ cursor: "pointer" }}
                            className={"btn btn-lg btn-mw btn-success"}
                            onClick={() => {
                              this.unarchiveFormAction();
                            }}
                            disabled={this.state.disabled ? true : false}
                          >
                            RESTORE
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* END UNARCHIVE MODAL  */}
              <div
                className="modal fade flexibleModal"
                tabIndex="-1"
                id="modalPreviewForm"
              >
                <div
                  className="modal-dialog modal-xl modal-dialog-top"
                  role="document"
                >
                  <div className="modal-content">
                    <a
                      style={{ cursor: "pointer" }}
                      className="close"
                      onClick={() =>
                        window.$("#modalPreviewForm").modal("hide")
                      }
                    >
                      <em className="icon ni ni-cross"></em>
                    </a>
                    <div className="modal-body">
                      <div className="nk-modal">
                        {this.state.previewContent}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal fade " tabIndex="-1" id="modalEmailForm">
                <div
                  className="modal-dialog modal-xl modal-dialog-top"
                  role="document"
                >
                  <div className="modal-content">
                    <div className="modal-header">
                      <div
                        className="modal-title"
                        style={{ textAlign: "center", fontSize: "20px" }}
                      >
                        <strong>
                          <em className="icon ni ni-grid-alt"></em>Email Form{" "}
                        </strong>
                      </div>

                      <a
                        href="#"
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                      >
                        <em className="icon ni ni-cross"></em>
                      </a>
                    </div>
                    <div className="modal-body">
                      <div className="nk-modal">
                        <div className="nk-block">
                          <div className="row g-gs">
                            <div className="nk-block-head">
                              <div className="nk-block-between-md g-4">
                                <div className="nk-block-head-content">
                                  <h5 className="nk-block-title fw-normal">
                                    Send Form
                                  </h5>
                                  {/*<div className="nk-block-des">
                                    <p>
                                      Here is list of package/product that you
                                      have subscribed.{" "}
                                      <span className="text-primary">
                                        <em className="icon ni ni-info"></em>
                                      </span>
                                    </p>
                                  </div>*/}
                                </div>
                                <div className="nk-block-head-content">
                                  <ul className="nk-block-tools gx-3">
                                    <li className="order-md-last">
                                      <a
                                        style={{ cursor: "pointer" }}
                                        onClick={() => {
                                          window
                                            .$("#modalEmailForm")
                                            .modal("hide");
                                          this.addMenuHistory(
                                            "/forms/view_form/" +
                                              this.state.form_accountno
                                          );
                                        }}
                                        className="btn btn-white btn-dim btn-outline-primary"
                                      >
                                        <span>View Submissions</span>
                                      </a>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            </div>

                            {this.state.emailErrorMessage !== "" ? (
                              <div className="col-sm-12">
                                <div className="alert alert-pro alert-danger">
                                  <div className="alert-text">
                                    <h6>{this.state.emailErrorMessageTitle}</h6>
                                    <p>{this.state.emailErrorMessage}</p>
                                  </div>
                                </div>
                              </div>
                            ) : null}
                            {this.state.emailSuccessMessage !== "" ? (
                              <div className="col-sm-12">
                                <div className="alert alert-pro alert-success">
                                  <div className="alert-text">
                                    <h6>Success</h6>
                                    <p>{this.state.emailSuccessMessage}</p>
                                  </div>
                                </div>
                              </div>
                            ) : null}

                            <div className="col-md-12">
                              <div className="form-group">
                                <ul className="nk-kycfm-control-list g-3">
                                  <li className="nk-kycfm-control-item">
                                    <input
                                      checked={
                                        this.state.select_agents === "general"
                                          ? true
                                          : false
                                      }
                                      onChange={this.handleChangeSelectAgents}
                                      className="nk-kycfm-control"
                                      type="radio"
                                      name="select_agents"
                                      id="select_agents2"
                                      data-title="Select Client"
                                      value="general"
                                    autoComplete="new-password" />
                                    <label
                                      className="nk-kycfm-label"
                                      htmlFor="select_agents2"
                                    >
                                      <span className="nk-kycfm-label-icon">
                                        <div className="label-icon ">
                                          <em
                                            className="icon ni ni-user-list fs-20"
                                            style={{ fontSize: "20px" }}
                                          ></em>
                                        </div>
                                      </span>
                                      <span className="nk-kycfm-label-text">
                                        General
                                      </span>
                                    </label>
                                  </li>
                                  <li className="nk-kycfm-control-item">
                                    <input
                                      checked={
                                        this.state.select_agents === "clients"
                                          ? true
                                          : false
                                      }
                                      onChange={this.handleChangeSelectAgents}
                                      className="nk-kycfm-control"
                                      type="radio"
                                      name="select_agents"
                                      id="select_agents1"
                                      data-title="Select Client"
                                      value="clients"
                                    autoComplete="new-password" />
                                    <label
                                      className="nk-kycfm-label"
                                      htmlFor="select_agents1"
                                    >
                                      <span className="nk-kycfm-label-icon">
                                        <div className="label-icon ">
                                          <em
                                            className="icon ni ni-user-list fs-20"
                                            style={{ fontSize: "20px" }}
                                          ></em>
                                        </div>
                                      </span>
                                      <span className="nk-kycfm-label-text">
                                        Select Client
                                      </span>
                                    </label>
                                  </li>
                                  <li className="nk-kycfm-control-item">
                                    <input
                                      checked={
                                        this.state.select_agents === "agents"
                                          ? true
                                          : false
                                      }
                                      onChange={this.handleChangeSelectAgents}
                                      className="nk-kycfm-control"
                                      type="radio"
                                      name="select_agents"
                                      id="select_agents"
                                      data-title={`Select ${localization.specificPortals.agentsLabel}`}
                                      value="agents"
                                    autoComplete="new-password" />
                                    <label
                                      className="nk-kycfm-label"
                                      htmlFor="select_agents"
                                    >
                                      <span className="nk-kycfm-label-icon">
                                        <div className="label-icon">
                                          <em
                                            className="icon ni ni-users"
                                            style={{ fontSize: "20px" }}
                                          ></em>
                                        </div>
                                      </span>
                                      <span className="nk-kycfm-label-text">
                                        Select{" "}
                                        {
                                          localization.specificPortals
                                            .agentLabel
                                        }
                                      </span>
                                    </label>
                                  </li>
                                  <li className="nk-kycfm-control-item">
                                    <input
                                      checked={
                                        this.state.select_agents === "suppliers"
                                          ? true
                                          : false
                                      }
                                      onChange={this.handleChangeSelectAgents}
                                      className="nk-kycfm-control"
                                      type="radio"
                                      name="select_agents"
                                      id="select_agents3"
                                      data-title={`Select ${localization.suppliersListing.text}`}
                                      value="suppliers"
                                    autoComplete="new-password" />
                                    <label
                                      className="nk-kycfm-label"
                                      htmlFor="select_agents3"
                                    >
                                      <span className="nk-kycfm-label-icon">
                                        <div className="label-icon">
                                          <em
                                            className="icon ni ni-users"
                                            style={{ fontSize: "20px" }}
                                          ></em>
                                        </div>
                                      </span>
                                      <span className="nk-kycfm-label-text">
                                        Select{" "}
                                        {localization.suppliersListing.text}
                                      </span>
                                    </label>
                                  </li>
                                </ul>
                              </div>
                            </div>
                            {this.state.select_agents === "clients" ? (
                              <div className="col-md-6">
                                <div className="form-group">
                                  <div className="form-label-group">
                                    <label className="form-label">
                                      Choose Client{" "}
                                      <span className="text-danger"></span>
                                    </label>
                                  </div>
                                  <div className="form-control-group">
                                    <Select2
                                      options={this.state.all_active_clients}
                                      name="selected_client_accountno"
                                      placeholder="Select a client to send the form."
                                      value={
                                        this.state.selected_client_accountno
                                      }
                                      autoComplete="off"
                                      emptyMessage="Clients not found"
                                      onChange={this.handleChangeSearch}
                                      isClearable
                                      isSearchable
                                      components={animatedComponents}
                                      styles={{
                                        control: (baseStyles, state) => ({
                                          ...baseStyles,
                                          lineHeight: "30px",
                                        }),
                                      }}
                                    />
                                  </div>
                                </div>
                              </div>
                            ) : null}

                            {this.state.select_agents === "agents" ? (
                              <div className="col-md-6">
                                <div className="form-group">
                                  <div className="form-label-group">
                                    <label className="form-label">
                                      Choose{" "}
                                      {localization.specificPortals.agentLabel}
                                      <span className="text-danger"></span>
                                    </label>
                                  </div>
                                  <div className="form-control-group">
                                    <Select2
                                      options={this.state.all_active_agents}
                                      name="selected_agent_accountno"
                                      placeholder={`Select a ${localization.specificPortals.agentText} to send the form.`}
                                      value={
                                        this.state.selected_agent_accountno
                                      }
                                      autoComplete="off"
                                      emptyMessage={`${localization.specificPortals.agentsText} not found`}
                                      onChange={this.handleChangeSearchAgents}
                                      isClearable
                                      isSearchable
                                      components={animatedComponents}
                                      styles={{
                                        control: (baseStyles, state) => ({
                                          ...baseStyles,
                                          lineHeight: "30px",
                                        }),
                                      }}
                                    />
                                  </div>
                                </div>
                              </div>
                            ) : null}
                            {this.state.select_agents === "suppliers" ? (
                              <div className="col-md-6">
                                <div className="form-group">
                                  <div className="form-label-group">
                                    <label className="form-label">
                                      Choose{" "}
                                      {localization.suppliersListing.text}
                                      <span className="text-danger"></span>
                                    </label>
                                  </div>
                                  <div className="form-control-group">
                                    <Select2
                                      options={this.state.all_active_suppliers}
                                      name="selected_agent_accountno"
                                      placeholder={`Select a ${localization.suppliersListing.text} to send the form.`}
                                      value={
                                        this.state.selected_agent_accountno
                                      }
                                      autoComplete="off"
                                      emptyMessage={`${localization.suppliersListing.text} not found`}
                                      onChange={this.handleChangeSearchAgents}
                                      isClearable
                                      isSearchable
                                      components={animatedComponents}
                                      styles={{
                                        control: (baseStyles, state) => ({
                                          ...baseStyles,
                                          lineHeight: "30px",
                                        }),
                                      }}
                                    />
                                  </div>
                                </div>
                              </div>
                            ) : null}
                            <div className="row col-md-12">
                              <div className="col-sm-6">
                                <div className="form-group mt-2">
                                  <label className="form-label" for="emailto">
                                    To Name <sup>*</sup>
                                  </label>
                                  <div className="form-control-wrap">
                                    <input
                                      type="text"
                                      className="form-control form-control-lg"
                                      id="emailtoname"
                                      name="emailtoname"
                                      value={this.state.emailtoname}
                                      onChange={this.handleChange}
                                      placeholder="Enter the full name"
                                    autoComplete="new-password" />
                                  </div>
                                </div>
                              </div>
                              <div className="col-sm-6">
                                <div className="form-group mt-2">
                                  <label className="form-label" for="emailto">
                                    To <sup>*</sup>
                                  </label>
                                  <div className="form-control-wrap">
                                    <input
                                      type="text"
                                      className="form-control form-control-lg"
                                      id="emailto"
                                      name="emailto"
                                      value={this.state.emailto}
                                      onChange={this.handleChange}
                                      placeholder="Enter email address"
                                    autoComplete="new-password" />
                                  </div>
                                </div>
                              </div>
                              <div className="col-sm-12 mt-2">
                                <div className="form-group">
                                  <label className="form-label" for="emailsubject">
                                    Subject <sup>*</sup>
                                  </label>
                                  <div className="form-control-wrap">
                                    <input
                                      type="text"
                                      className="form-control form-control-lg"
                                      id="emailsubject"
                                      name="emailsubject"
                                      value={this.state.emailsubject}
                                      onChange={this.handleChange}
                                      placeholder="Email Subject"
                                    autoComplete="new-password" />
                                  </div>
                                </div>
                              </div>
                              <div className="col-sm-12 mt-2">
                                <div className="form-group">
                                  <label className="form-label" for="emailcontent">
                                    Custom Message <sup>*</sup>
                                  </label>
                                  <div className="form-control-wrap">
                                    <textarea
                                      className="form-control"
                                      id="emailcontent"
                                      name="emailcontent"
                                      value={this.state.emailcontent}
                                      onChange={this.handleChange}
                                    ></textarea>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="col-sm-12 mt-2 d-flex justify-content-end">
                              <div className="nk-block-head-content">
                                <ul className="nk-block-tools gx-3">
                                  {this.state.email_button === true ? (
                                    <button
                                      className="btn btn-primary"
                                      type="button"
                                      disabled
                                    >
                                      <span
                                        className="spinner-grow spinner-grow-sm"
                                        role="status"
                                        aria-hidden="true"
                                      ></span>
                                      <span> Processing... </span>
                                    </button>
                                  ) : (
                                    <li>
                                      <a
                                        onClick={() => this.submitFormEmail()}
                                        style={{
                                          cursor: "pointer",
                                          color: "#fff",
                                        }}
                                        className="btn btn-primary"
                                      >
                                        <em className="icon ni ni-check-round-cut"></em>{" "}
                                        <span>Send Email</span>{" "}
                                      </a>
                                    </li>
                                  )}
                                </ul>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="modal fade flexibleModal"
                tabIndex="-1"
                id="modalAssignForm"
              >
                <div
                  className="modal-dialog modal-lg modal-dialog-top"
                  role="document"
                >
                  <div className="modal-content">
                    <div className="modal-header">
                      <div
                        className="modal-title"
                        style={{ textAlign: "center", fontSize: "20px" }}
                      >
                        <strong>
                          <em className="icon ni ni-user-check"></em> Assign
                          Form to{" "}
                          <sup>
                            <small className="text-soft">
                              Clients /{" "}
                              {localization.specificPortals.agentsLabel} /
                              Suppliers
                            </small>
                          </sup>
                        </strong>
                      </div>
                      <a
                        href="#"
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                      >
                        <em className="icon ni ni-cross"></em>
                      </a>
                    </div>

                    <div className="modal-body text-left">
                      <div className="nk-modal">
                        <div className="nk-modal-text">
                          {this.state.assignModalLoader === true ? (
                            tableLoader()
                          ) : (
                            <>
                              {/* Alerts */}
                              {this.state.errorMessageAssignModal && (
                                <div
                                  className="example-alert"
                                  style={{ marginBottom: "15px" }}
                                >
                                  <div className="alert alert-pro alert-danger">
                                    <div className="alert-text">
                                      <h4>Error</h4>
                                      <p>
                                        {this.state.errorMessageAssignModal}
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              )}

                              {this.state.successMessageAssignModal && (
                                <div
                                  className="example-alert"
                                  style={{ marginBottom: "15px" }}
                                >
                                  <div className="alert alert-pro alert-success">
                                    <div className="alert-text">
                                      <h4>Success</h4>
                                      <p>
                                        {this.state.successMessageAssignModal}
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              )}

                              {/* Tabs */}
                              <ul className="nav nav-tabs">
                                <li className="nav-item">
                                  <a
                                    className={`nav-link ${
                                      this.state.assignTab === "clients"
                                        ? "active"
                                        : ""
                                    }`}
                                    href="#"
                                    onClick={() =>
                                      this.setState({ assignTab: "clients" })
                                    }
                                  >
                                    <em className="icon ni ni-user-list"></em>
                                    <span>Clients</span>
                                  </a>
                                </li>
                                <li className="nav-item">
                                  <a
                                    className={`nav-link ${
                                      this.state.assignTab === "agents"
                                        ? "active"
                                        : ""
                                    }`}
                                    href="#"
                                    onClick={() =>
                                      this.setState({ assignTab: "agents" })
                                    }
                                  >
                                    <em className="icon ni ni-users"></em>
                                    <span>
                                      {localization.specificPortals.agentsLabel}
                                    </span>
                                  </a>
                                </li>
                                <li className="nav-item">
                                  <a
                                    className={`nav-link ${
                                      this.state.assignTab === "suppliers"
                                        ? "active"
                                        : ""
                                    }`}
                                    href="#"
                                    onClick={() =>
                                      this.setState({ assignTab: "suppliers" })
                                    }
                                  >
                                    <em className="icon ni ni-user-circle"></em>
                                    <span>Suppliers</span>
                                  </a>
                                </li>
                              </ul>

                              {/* Tab Content */}
                              <div className="tab-content mt-3">
                                {/* Clients Tab */}
                                {this.state.assignTab === "clients" && (
                                  <div className="tab-pane active">
                                    {this.state.clientsList?.length > 0 ? (
                                      <div
                                        className="form-group"
                                        style={{
                                          display: "flex",
                                          flexDirection: "column",
                                        }}
                                      >
                                        <FormControlLabel
                                          control={
                                            <Checkbox
                                              checked={
                                                this.state.selectAllClients
                                              }
                                              onChange={
                                                this
                                                  .handleSelectAllClientsChange
                                              }
                                              color="primary"
                                            />
                                          }
                                          label="Select all Clients"
                                          style={{
                                            width: "max-content",
                                            marginBottom: "10px",
                                          }}
                                        />
                                        <Autocomplete
                                          multiple
                                          id="clients-autocomplete"
                                          options={this.state.clientsList}
                                          disableCloseOnSelect
                                          getOptionLabel={(option) =>
                                            option.label
                                          }
                                          value={this.state.clientsList.filter(
                                            (c) =>
                                              this.state.selectedClients.includes(
                                                c.value
                                              )
                                          )}
                                          onChange={this.handleClientChange}
                                          renderOption={(
                                            option,
                                            { selected }
                                          ) => (
                                            <Fragment>
                                              <Checkbox
                                                icon={icon}
                                                checkedIcon={checkedIcon}
                                                style={{ marginRight: 8 }}
                                                checked={selected}
                                              />
                                              {option.label}
                                            </Fragment>
                                          )}
                                          style={{ width: "100%" }}
                                          renderInput={(params) => (
                                            <MutextField
                                              {...params}
                                              label="Select Clients"
                                            autoComplete="new-password"
                                            />
                                          )}
                                        />
                                        <div className="nk-modal-action text-right mt-3">
                                          <a
                                            href="#"
                                            className="btn btn-lg btn-mw btn-primary"
                                            onClick={
                                              this.handleSubmitAssignFormClient
                                            }
                                            disabled={
                                              this.state.disableAssignBtn
                                            }
                                          >
                                            Assign to Clients
                                          </a>
                                        </div>
                                      </div>
                                    ) : (
                                      <p>No clients found</p>
                                    )}
                                  </div>
                                )}

                                {/* Agents Tab */}
                                {this.state.assignTab === "agents" && (
                                  <div className="tab-pane active">
                                    {this.state.channelPartnersList?.length >
                                    0 ? (
                                      <div
                                        className="form-group"
                                        style={{
                                          display: "flex",
                                          flexDirection: "column",
                                        }}
                                      >
                                        <FormControlLabel
                                          control={
                                            <Checkbox
                                              checked={
                                                this.state
                                                  .selectAllChannelPartners
                                              }
                                              onChange={
                                                this
                                                  .handleSelectAllChannelPartnersChange
                                              }
                                              color="primary"
                                            />
                                          }
                                          label={`Select all ${localization.specificPortals.agentsLabel}`}
                                          style={{
                                            width: "max-content",
                                            marginBottom: "10px",
                                          }}
                                        />
                                        <Autocomplete
                                          multiple
                                          id="channel-partners-autocomplete"
                                          options={
                                            this.state.channelPartnersList
                                          }
                                          disableCloseOnSelect
                                          getOptionLabel={(option) =>
                                            option.label
                                          }
                                          value={this.state.channelPartnersList.filter(
                                            (p) =>
                                              this.state.selectedChannelPartners.includes(
                                                p.value
                                              )
                                          )}
                                          onChange={
                                            this.handleChannelPartnerChange
                                          }
                                          renderOption={(
                                            option,
                                            { selected }
                                          ) => (
                                            <Fragment>
                                              <Checkbox
                                                icon={icon}
                                                checkedIcon={checkedIcon}
                                                style={{ marginRight: 8 }}
                                                checked={selected}
                                              />
                                              {option.label}
                                            </Fragment>
                                          )}
                                          style={{ width: "100%" }}
                                          renderInput={(params) => (
                                            <MutextField
                                              {...params}
                                              label={`Select ${localization.specificPortals.agentsLabel}`}
                                            autoComplete="new-password"
                                            />
                                          )}
                                        />
                                        <div className="nk-modal-action text-right mt-3">
                                          <a
                                            href="#"
                                            className="btn btn-lg btn-mw btn-primary"
                                            onClick={
                                              this.handleSubmitAssignFormAgents
                                            }
                                            disabled={
                                              this.state.disableAssignBtn
                                            }
                                          >
                                            {`Assign to ${localization.specificPortals.agentsLabel}`}
                                          </a>
                                        </div>
                                      </div>
                                    ) : (
                                      <p>
                                        No{" "}
                                        {
                                          localization.specificPortals
                                            .agentsLabel
                                        }{" "}
                                        found
                                      </p>
                                    )}
                                  </div>
                                )}

                                {/* Suppliers Tab */}
                                {this.state.assignTab === "suppliers" && (
                                  <div className="tab-pane active">
                                    {this.state.suppliersList?.length > 0 ? (
                                      <div
                                        className="form-group"
                                        style={{
                                          display: "flex",
                                          flexDirection: "column",
                                        }}
                                      >
                                        <FormControlLabel
                                          control={
                                            <Checkbox
                                              checked={
                                                this.state.selectAllSuppliers
                                              }
                                              onChange={
                                                this
                                                  .handleSelectAllSuppliersChange
                                              }
                                              color="primary"
                                            />
                                          }
                                          label="Select all Suppliers"
                                          style={{
                                            width: "max-content",
                                            marginBottom: "10px",
                                          }}
                                        />
                                        <Autocomplete
                                          multiple
                                          id="suppliers-autocomplete"
                                          options={this.state.suppliersList}
                                          disableCloseOnSelect
                                          getOptionLabel={(option) =>
                                            option.label
                                          }
                                          value={this.state.suppliersList.filter(
                                            (s) =>
                                              this.state.selectedSuppliers.includes(
                                                s.value
                                              )
                                          )}
                                          onChange={this.handleSupplierChange}
                                          renderOption={(
                                            option,
                                            { selected }
                                          ) => (
                                            <Fragment>
                                              <Checkbox
                                                icon={icon}
                                                checkedIcon={checkedIcon}
                                                style={{ marginRight: 8 }}
                                                checked={selected}
                                              />
                                              {option.label}
                                            </Fragment>
                                          )}
                                          style={{ width: "100%" }}
                                          renderInput={(params) => (
                                            <MutextField
                                              {...params}
                                              label="Select Suppliers"
                                            autoComplete="new-password"
                                            />
                                          )}
                                        />
                                        <div className="nk-modal-action text-right mt-3">
                                          <a
                                            href="#"
                                            className="btn btn-lg btn-mw btn-primary"
                                            onClick={
                                              this
                                                .handleSubmitAssignFormSupplier
                                            }
                                            disabled={
                                              this.state.disableAssignBtn
                                            }
                                          >
                                            Assign to Suppliers
                                          </a>
                                        </div>
                                      </div>
                                    ) : (
                                      <p>No suppliers found</p>
                                    )}
                                  </div>
                                )}
                              </div>
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* <div
                className="modal fade flexibleModal"
                tabIndex="-1"
                id="modalAssignForm"
              >
                <div
                  className="modal-dialog modal-xl modal-dialog-top"
                  role="document"
                >
                  <div className="modal-content">
                    <div className="modal-header">
                      <div
                        className="modal-title"
                        style={{ textAlign: "center", fontSize: "20px" }}
                      >
                        <strong>
                          <em className="icon ni ni-user-check"></em>Assign Form
                          to{" "}
                          <sup>
                            <small className="text-soft">
                              {localization.specificPortals.agentsLabel}/Clients/Suppliers
                            </small>
                          </sup>
                        </strong>
                      </div>
                      <a
                        href="#"
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                      >
                        <em className="icon ni ni-cross"></em>
                      </a>
                    </div>

                    <div className="modal-body text-left">
                      <div className="nk-modal">
                        <div className="nk-modal-text">
                          {this.state.assignModalLoader === true ? (
                            tableLoader()
                          ) : (
                            <>
                              {this.state.errorMessageAssignModal !== "" ? (
                                <div
                                  className="example-alert "
                                  style={{ marginBottom: "15px" }}
                                >
                                  <div className="alert alert-pro alert-danger">
                                    <div className="alert-text">
                                      <h4>Error</h4>
                                      <p>
                                        {this.state.errorMessageAssignModal}
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              ) : null}
                              {this.state.successMessageAssignModal !== "" ? (
                                <div
                                  className="example-alert "
                                  style={{ marginBottom: "15px" }}
                                >
                                  <div className="alert alert-pro alert-success">
                                    <div className="alert-text">
                                      <h4>Success</h4>
                                      <p>
                                        {this.state.successMessageAssignModal}
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              ) : null}

                              <div className="card card-bordered card-preview">
                                <table className="table table-orders">
                                  <thead className="tb-odr-head">
                                    <tr className="tb-odr-item">
                                      <th
                                        width="33%"
                                        style={{
                                          borderRight: "1px solid #dbdfea",
                                        }}
                                      >
                                        <span className="tb-odr-action">
                                          {
                                            localization.specificPortals
                                              .agentsLabel
                                          }
                                        </span>
                                      </th>
                                      <th width="33%">
                                        <span className="tb-odr-action">
                                          Clients
                                        </span>
                                      </th>
                                      <th width="33%">
                                        <span className="tb-odr-action">
                                          Suppliers
                                        </span>
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody className="tb-odr-body">
                                    {this.state.channelPartnersList &&
                                      this.state.channelPartnersList.length >
                                      0 ? (
                                      <tr className="tb-odr-item customStyle_tb-odr-item_forms">
                                        <td
                                          style={{
                                            borderRight: "1px solid #dbdfea",
                                          }}
                                        >
                                          <div
                                            className="form-group"
                                            style={{
                                              display: "flex",
                                              flexDirection: "column",
                                            }}
                                          >
                                            <FormControlLabel
                                              control={
                                                <Checkbox
                                                  checked={
                                                    this.state
                                                      .selectAllChannelPartners
                                                  }
                                                  onChange={
                                                    this
                                                      .handleSelectAllChannelPartnersChange
                                                  }
                                                  name="selectAllChannelPartners"
                                                  color="primary"
                                                />
                                              }
                                              label={`Select all ${localization.specificPortals.agentsLabel}`}
                                              style={{
                                                width: "max-content",
                                                marginBottom: "10px",
                                                float: "right",
                                              }}
                                            />

                                            <Autocomplete
                                              multiple
                                              id="channel-partners-autocomplete"
                                              options={
                                                this.state.channelPartnersList
                                              }
                                              disableCloseOnSelect
                                              getOptionLabel={(option) =>
                                                option.label
                                              }
                                              value={this.state.channelPartnersList.filter(
                                                (partner) =>
                                                  this.state.selectedChannelPartners.includes(
                                                    partner.value
                                                  )
                                              )}
                                              onChange={
                                                this.handleChannelPartnerChange
                                              }
                                              getOptionSelected={(
                                                option,
                                                value
                                              ) => option.value === value.value}
                                              renderOption={(
                                                option,
                                                { selected }
                                              ) => (
                                                <Fragment>
                                                  <Checkbox
                                                    icon={icon}
                                                    checkedIcon={checkedIcon}
                                                    style={{ marginRight: 8 }}
                                                    checked={selected}
                                                  />
                                                  {option.label}
                                                </Fragment>
                                              )}
                                              style={{ width: "100%" }}
                                              renderInput={(params) => (
                                                <MutextField
                                                  {...params}
                                                  label={`Select ${localization.specificPortals.agentsLabel}`}
                                                  placeholder=""
                                                autoComplete="new-password"
                                                />
                                              )}
                                            />
                                          </div>
                                        </td>
                                        <td
                                          style={{
                                            paddingLeft: "16px",
                                            borderRight: "1px solid #dbdfea",
                                          }}
                                        >
                                          {this.state.clientsList &&
                                            this.state.clientsList.length > 0 ? (
                                            <div
                                              className="form-group"
                                              style={{
                                                display: "flex",
                                                flexDirection: "column",
                                              }}
                                            >
                                              <FormControlLabel
                                                control={
                                                  <Checkbox
                                                    checked={
                                                      this.state
                                                        .selectAllClients
                                                    }
                                                    onChange={
                                                      this
                                                        .handleSelectAllClientsChange
                                                    }
                                                    name="selectAll"
                                                    color="primary"
                                                  />
                                                }
                                                label="Select all Clients"
                                                style={{
                                                  width: "max-content",
                                                  marginBottom: "10px",
                                                  float: "right",
                                                }}
                                              />
                                              <Autocomplete
                                                multiple
                                                id="clients-autocomplete"
                                                options={this.state.clientsList}
                                                disableCloseOnSelect
                                                getOptionLabel={(option) =>
                                                  option.label
                                                }
                                                value={this.state.clientsList.filter(
                                                  (client) =>
                                                    this.state.selectedClients.includes(
                                                      client.value
                                                    )
                                                )}
                                                onChange={
                                                  this.handleClientChange
                                                }
                                                getOptionSelected={(
                                                  option,
                                                  value
                                                ) =>
                                                  option.value === value.value
                                                }
                                                renderOption={(
                                                  option,
                                                  { selected }
                                                ) => (
                                                  <Fragment>
                                                    <Checkbox
                                                      icon={icon}
                                                      checkedIcon={checkedIcon}
                                                      style={{ marginRight: 8 }}
                                                      checked={selected}
                                                    />
                                                    {option.label}
                                                  </Fragment>
                                                )}
                                                style={{ width: "100%" }}
                                                renderInput={(params) => (
                                                  <MutextField
                                                    {...params}
                                                    label="Select Clients"
                                                    placeholder=""
                                                  autoComplete="new-password"
                                                  />
                                                )}
                                              />
                                            </div>
                                          ) : null}
                                        </td>
                                        <td
                                          style={{
                                            paddingLeft: "16px",
                                          }}
                                        >
                                          {this.state.suppliersList &&
                                            this.state.suppliersList.length > 0 ? (
                                            <div
                                              className="form-group"
                                              style={{
                                                display: "flex",
                                                flexDirection: "column",
                                              }}
                                            >
                                              <FormControlLabel
                                                control={
                                                  <Checkbox
                                                    checked={
                                                      this.state
                                                        .selectAllSuppliers
                                                    }
                                                    onChange={
                                                      this
                                                        .handleSelectAllSuppliersChange
                                                    }
                                                    name="selectAll"
                                                    color="primary"
                                                  />
                                                }
                                                label="Select all Suppliers"
                                                style={{
                                                  width: "max-content",
                                                  marginBottom: "10px",
                                                  float: "right",
                                                }}
                                              />
                                              <Autocomplete
                                                multiple
                                                id="clients-autocomplete"
                                                options={this.state.suppliersList}
                                                disableCloseOnSelect
                                                getOptionLabel={(option) =>
                                                  option.label
                                                }
                                                value={this.state.suppliersList.filter(
                                                  (client) =>
                                                    this.state.selectedSuppliers.includes(
                                                      client.value
                                                    )
                                                )}
                                                onChange={
                                                  this.handleSupplierChange
                                                }
                                                getOptionSelected={(
                                                  option,
                                                  value
                                                ) =>
                                                  option.value === value.value
                                                }
                                                renderOption={(
                                                  option,
                                                  { selected }
                                                ) => (
                                                  <Fragment>
                                                    <Checkbox
                                                      icon={icon}
                                                      checkedIcon={checkedIcon}
                                                      style={{ marginRight: 8 }}
                                                      checked={selected}
                                                    />
                                                    {option.label}
                                                  </Fragment>
                                                )}
                                                style={{ width: "100%" }}
                                                renderInput={(params) => (
                                                  <MutextField
                                                    {...params}
                                                    label="Select Suppliers"
                                                    placeholder=""
                                                  autoComplete="new-password"
                                                  />
                                                )}
                                              />
                                            </div>
                                          ) : null}
                                        </td>
                                      </tr>
                                    ) : null}
                                    {this.state.channelPartnersList &&
                                      this.state.channelPartnersList.length >
                                      0 ? (
                                      <>
                                        <tr>
                                          <td>
                                            <div className="nk-modal-action  text-right">
                                              <a
                                                href="#"
                                                className="btn btn-lg btn-mw btn-primary "
                                                onClick={() => {
                                                  this.handleSubmitAssignFormAgents();
                                                }}
                                                disabled={
                                                  this.state.disableAssignBtn
                                                }
                                              >
                                                {`Assign to ${localization.specificPortals.agentsLabel}`}
                                              </a>
                                            </div>
                                          </td>
                                          <td>
                                            <div className="nk-modal-action  text-right">
                                              <a
                                                href="#"
                                                className="btn btn-lg btn-mw btn-primary "
                                                onClick={() => {
                                                  this.handleSubmitAssignFormClient();
                                                }}
                                                disabled={
                                                  this.state.disableAssignBtn
                                                }
                                              >
                                                Assign to Clients
                                              </a>
                                            </div>
                                          </td>
                                          {this.state.suppliersList &&
                                            this.state.suppliersList.length > 0 ? (
                                            <td>
                                              <div className="nk-modal-action  text-right">
                                                <a
                                                  href="#"
                                                  className="btn btn-lg btn-mw btn-primary "
                                                  onClick={() => {
                                                    this.handleSubmitAssignFormSupplier();
                                                  }}
                                                  disabled={
                                                    this.state.disableAssignBtn
                                                  }
                                                >
                                                  Assign to Suppliers
                                                </a>
                                              </div>
                                            </td>
                                          ) : null}
                                        </tr>
                                      </>
                                    ) : null}
                                  </tbody>
                                </table>
                              </div>
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div> */}
              {/* END DELETE MODAL  */}
              {/* START Zap MODAL  */}
              <div className="modal fade" tabIndex="-1" id="modalZapAlert">
                <div className="modal-dialog" role="document">
                  <div className="modal-content">
                    <a
                      style={{ cursor: "pointer" }}
                      className="close"
                      onClick={() => this.closeZapForm()}
                    >
                      <em className="icon ni ni-cross"></em>
                    </a>
                    <div className="modal-body modal-body-lg text-center">
                      <div className="nk-modal">
                        <em
                          className={`nk-modal-icon icon icon-circle icon-circle-xxl ni ${
                            this.state.zap_for_zap === 1
                              ? "ni-cross bg-danger"
                              : "ni-check bg-success"
                          }`}
                        ></em>

                        <h4 className="nk-modal-title">
                          {this.state.zap_for_zap === 1
                            ? "Remove for Zapier?"
                            : "Enable for Zapier?"}
                        </h4>
                        <div className="nk-modal-text">
                          {this.state.errorMessaged !== "" ? (
                            <div
                              className="example-alert"
                              style={{ marginBottom: "15px" }}
                            >
                              <div className="alert alert-pro alert-danger">
                                <div className="alert-text">
                                  <h4>Error</h4>
                                  <p>{this.state.errorMessaged}</p>
                                </div>
                              </div>
                            </div>
                          ) : null}
                          {this.state.successMessaged !== "" ? (
                            <div
                              className="example-alert"
                              style={{ marginBottom: "15px" }}
                            >
                              <div className="alert alert-pro alert-success">
                                <div className="alert-text">
                                  <h4>Success</h4>
                                  <p>{this.state.successMessaged}</p>
                                </div>
                              </div>
                            </div>
                          ) : null}
                          <div className="caption-text">
                            {this.state.zap_for_zap === 1
                              ? "Are you sure you want to disable this form for Zapier?"
                              : "Are you sure you want to enable this form for Zapier?"}
                          </div>
                        </div>
                        <div className="nk-modal-action">
                          <a
                            style={{ cursor: "pointer" }}
                            className="btn btn-lg btn-mw btn-primary"
                            onClick={() => this.closeZapForm()}
                          >
                            CANCEL
                          </a>
                          {"  "}
                          <button
                            style={{ cursor: "pointer" }}
                            className={`btn btn-lg btn-mw ${
                              this.state.zap_for_zap === 1
                                ? "btn-danger"
                                : "btn-success"
                            }`}
                            onClick={() => {
                              this.enableZapForm();
                            }}
                            disabled={this.state.disabled}
                          >
                            {this.state.zap_for_zap === 1 ? "REMOVE" : "ENABLE"}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* START Zap MODAL  */}
              {/* START DUPLICATE MODAL  */}
              <div className="modal fade" tabIndex="-1" id="modalDuplicateAlert">
                <div className="modal-dialog" role="document">
                  <div className="modal-content">
                    <a
                      style={{ cursor: "pointer" }}
                      className="close"
                      onClick={() => this.closeDuplicateForm()}
                    >
                      <em className="icon ni ni-cross"></em>
                    </a>
                    <div className="modal-body modal-body-lg text-center">
                      <div className="nk-modal">
                        <em className="nk-modal-icon icon icon-circle icon-circle-xxl ni ni-copy bg-primary"></em>

                        <h4 className="nk-modal-title">Duplicate Form?</h4>
                        <div className="nk-modal-text">
                          {this.state.errorMessaged !== "" ? (
                            <div
                              className="example-alert"
                              style={{ marginBottom: "15px" }}
                            >
                              <div className="alert alert-pro alert-danger">
                                <div className="alert-text">
                                  <h4>Error</h4>
                                  <p>{this.state.errorMessaged}</p>
                                </div>
                              </div>
                            </div>
                          ) : null}
                          {this.state.successMessaged !== "" ? (
                            <div
                              className="example-alert"
                              style={{ marginBottom: "15px" }}
                            >
                              <div className="alert alert-pro alert-success">
                                <div className="alert-text">
                                  <h4>Success</h4>
                                  <p>{this.state.successMessaged}</p>
                                </div>
                              </div>
                            </div>
                          ) : null}
                          <div className="caption-text">
                            Are you sure you want to duplicate this form?
                            <br />
                            A copy will be created.
                          </div>
                        </div>
                        <div className="nk-modal-action">
                          <a
                            style={{ cursor: "pointer" }}
                            className="btn btn-lg btn-mw btn-light"
                            onClick={() => this.closeDuplicateForm()}
                          >
                            CANCEL
                          </a>
                          {"  "}
                          <button
                            style={{ cursor: "pointer" }}
                            className={"btn btn-lg btn-mw btn-primary"}
                            onClick={() => {
                              this.duplicateForm();
                            }}
                            disabled={this.state.disabled ? true : false}
                          >
                            DUPLICATE
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* END DUPLICATE MODAL  */}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    defaultSettings: state.settings,
    is_msa_signed: state.is_msa_signed,
    userRoleItems: state.userRoleItems,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    addSettings: (payload) => dispatch(addSettings(payload)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Forms);
